<template>
  <div>
    <ul class="step-list">
      <li
        v-for="(step, index) in steps"
        :key="index"
        class="step"
        :class="{ active: index == currentStep, complete: index < currentStep }"
        @click="$emit('change', index)"
      >
        <span
          class="step-title"
          :class="{ downgrade: isDowngrade }"
        >
          {{ step }}
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Steps',
  props: {
    mobile: {
      type: Boolean,
      default: false,
    },
    steps: {
      type: Array,
      required: true,
    },
    currentStep: {
      type: Number,
      default: 0,
      validator: (value) => value >= 0,
    },
    isDowngrade: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    this.currentStep = Math.min(Math.max(0, this.currentStep), this.steps.length - 1);
  },
  updated() {
    this.currentStep = Math.min(Math.max(0, this.currentStep), this.steps.length - 1);
  },
};
</script>

<style lang="scss">
@import "../variables.scss";

@mixin arrow ($concave) {
  content: "";
  position: absolute;
  border-style: solid;
  z-index: 1;

  @if $concave {
    top: 0px;
    top: 0px;
    right: -13px;
    width: 0;
    height: 0;
    border-width: 11px 0 14px 13px;
  } @else {
    top: 3px;
    left: -10px;
    width: 18px;
    height: 18px;
    border-style: solid;
    border-width: 1px 1px 0px 0px;
  }
}

.step-list {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  justify-content: space-between;
}

.step {
  padding: 0;
  margin: 0;
  flex-grow: 1;
  font-size: 12px;
  text-align: center;
  font-weight: 600;
  text-transform: uppercase;
  cursor: pointer;
}

@media screen and (max-width: $license-modal-mobile) {
  .step-list {
    counter-reset: section;
  }

  .step {
    flex-basis: 0;
    height: 25px;
    line-height: 25px;
    color: $primary-fg-color;
    background: rgba($primary-color, 0.5);
    position: relative;
    border: 1px solid transparent;

    &.active {
      background: rgb(2,117,216);

      &:not(:last-child):after {
        @include arrow(true);
        border-color: transparent transparent transparent $primary-color;
      }
    }

    &.complete {
      background: #fff;
      color: $primary-color;
      border-top: 1px solid #E5E5E9;
      border-bottom: 1px solid #E5E5E9;

      &:first-child {
        border-left: 1px solid #E5E5E9;
      }

      &:not(:first-child):before {
        @include arrow(false);
        border-color: #E5E5E9 #E5E5E9 transparent transparent;
        transform: rotate(45deg);
      }

      &:not(:last-child):after {
        @include arrow(true);
        border-color: transparent transparent transparent #fff;
      }
    }
    &:nth-child(2).complete > .downgrade.step-title {
      color: #8E9BAA;
      font-weight: 600;
    }

    &:first-child {
      border-top-left-radius: 3px;
      border-bottom-left-radius: 3px;
    }

    &:last-child {
      border-top-right-radius: 3px;
      border-bottom-right-radius: 3px;
    }
  }

  .step-title {
    visibility: hidden;

    &:before {
      visibility: visible;
      counter-increment: section;
      content: "Step " counter(section);
      text-align: center;
      display: block;
    }
  }
}

@media screen and (min-width: $license-modal-mobile) {
  .step-list {
    flex-wrap: wrap;
    border-bottom: 1px solid #E5E5E9;
  }

  .step {
    color: #8E9BAA;
    padding-bottom: 5px;
    display: inline-block;
    border-bottom: 4px solid transparent;

    &.active {
      color: #272727;
      border-bottom: 4px solid $primary-color;
    }

    &.complete {
      color: $primary-color;
      font-weight: 400;
    }
    &:nth-child(2).complete > .downgrade.step-title {
      color: #8E9BAA;
      font-weight: 600;
    }
  }
}
</style>
